import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";
import { storageHelper } from "lib/helpers";

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: storageHelper.get("lang") || "en",
    backend: {
      /* translation file path */
      loadPath: "/locales/{{lng}}.json",
    },
    fallbackLng: "en",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
